import { BaseAPI } from './BaseAPI.js'
import { AddressBookEntry } from '../types/AddressBookEntry.js'

export default class AddressBookEntriesAPI extends BaseAPI<AddressBookEntry> {
  override get resource(): string {
    return '/addressBookEntries'
  }
}
